import {
  CostOfLivingFormState,
  DEFAULT_FORM_STATE,
  GLOBAL_LIVING_KEY,
  migrateFormState,
  sessionKey,
} from "../components/PropertyLiving/types";

function migrateFromLegacyStorage(): CostOfLivingFormState | null {
  try {
    const globalRaw = localStorage.getItem(GLOBAL_LIVING_KEY);
    if (globalRaw) {
      return migrateFormState(JSON.parse(globalRaw));
    }

    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (!key?.startsWith("le-mday-")) continue;
      const raw = sessionStorage.getItem(key);
      if (!raw) continue;
      const parsed = migrateFormState(JSON.parse(raw));
      saveLivingPreferences(parsed);
      return parsed;
    }
  } catch {
    // ignore corrupt storage
  }
  return null;
}

export function loadLivingPreferences(): CostOfLivingFormState {
  try {
    const raw = localStorage.getItem(GLOBAL_LIVING_KEY);
    if (raw) return migrateFormState(JSON.parse(raw));
  } catch {
    // fall through
  }

  const legacy = migrateFromLegacyStorage();
  if (legacy) return legacy;

  return { ...DEFAULT_FORM_STATE };
}

export function saveLivingPreferences(form: CostOfLivingFormState): void {
  try {
    localStorage.setItem(GLOBAL_LIVING_KEY, JSON.stringify(form));
  } catch {
    // ignore quota errors
  }
}

/** @deprecated one-time migration helper */
export function legacySessionKey(propertyId: number): string {
  return sessionKey(propertyId);
}
